/**
 * Where sign-in lives (f17.3, Sign in with GFT).
 *
 * The API runs the whole Microsoft sign-in and keeps the session in an HttpOnly
 * cookie no script can read, so the browser only ever needs two things: the
 * address that starts it, and a way back to the sign-in screen when a session
 * ends. `next` is where to land afterwards; only a path on this site is kept,
 * here and again on the server.
 */

export const SIGN_IN_PATH = '/signin';

/** A path on this site, or `/`: one leading slash, never `//`, no scheme. */
export function safeNext(path: string | null | undefined): string {
  if (!path || !path.startsWith('/') || path.startsWith('//') || path.includes('\\')) return '/';
  if (path.startsWith(SIGN_IN_PATH)) return '/';
  return path;
}

/** The API's sign-in start, carrying where to land afterwards. */
export function signInHref(next: string | null | undefined): string {
  return `/api/auth/sso?next=${encodeURIComponent(safeNext(next))}`;
}

/** The sign-in screen, remembering the current page. */
export function signInScreen(next: string): string {
  return `${SIGN_IN_PATH}?next=${encodeURIComponent(safeNext(next))}`;
}

let leaving = false;

/**
 * A session ended (12 h absolute, 2 h idle, or revoked): back to the sign-in
 * screen -- once, however many requests fail together, and never from the
 * sign-in screen itself.
 */
export function returnToSignIn(): void {
  if (leaving || window.location.pathname.startsWith(SIGN_IN_PATH)) return;
  leaving = true;
  window.location.assign(signInScreen(window.location.pathname + window.location.search));
}
